import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "16",
  "data-name": "Ikona USER"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#626997",
      d: "M13.323 16a.69.69 0 0 1-.677-.7c-.008-2.7-1.655-4.893-3.673-4.893H5.028c-2.018 0-3.665 2.2-3.673 4.893a.69.69 0 0 1-.679.7.69.69 0 0 1-.676-.708 7.2 7.2 0 0 1 1.429-4.4 4.55 4.55 0 0 1 3.6-1.9h3.943a4.55 4.55 0 0 1 3.6 1.9 7.2 7.2 0 0 1 1.428 4.4.69.69 0 0 1-.675.7Z",
      "data-name": "Path 16542"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#626997",
      d: "M6.999 0a4 4 0 1 1-4 4 4 4 0 0 1 4-4m0 6.588A2.588 2.588 0 1 0 4.411 4a2.59 2.59 0 0 0 2.588 2.588",
      "data-name": "Ellipse 394"
    }, null, -1)
  ]))]))
}
export default { render: render }